import React, { Component } from "react";
import TodoDataService from '../../hooks/services'
import axios from "axios";

// -----------Importar Componentes de Terceros------------------
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';


import PlanHero from '../../components/Planes_futuros/PlanHero';
import WhatIsPlan from '../../components/Planes_futuros/WhatIsPlan';
import LoveDecision from '../../components/Planes_futuros/LoveDecision';
import FAQ from '../../components/Planes_futuros/FAQ';
import Testimonials from '../../components/Planes_futuros/Testimonials';



const datalogin = { email: "apicolumba@funeralescolumba.com.mx", password: "pG7-tl3[02835}4P" };
const UrlToken = TodoDataService.GetHostRestApi() + '/usuario/login/';

class PlanesFuturos extends Component {
  intervalId = null;

  state = {
    Token: '',
    Error: '',
    DataTestimonios: []
  }


  // Método para obtener el token de autenticación
  GetPeticionToken = async () => {
    let result = '';
    await axios.post(UrlToken, datalogin)
      .then(response => {
        this.setState({ Token: 'Bearer ' + response.data.token });
        result = 'Bearer ' + response.data.token;
      })
      .catch(error => {
        console.log(error);
      });
    return result;
  }


  

  scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  async componentDidMount() {
    this.scrollToTop();

    let token = await this.GetPeticionToken(); // Obtiene el token de autenticación

    this.setState({DataTestimonios: await TodoDataService.GetListTestimonios('/ComentariosGoogle/comentarios','/ComentariosGoogle/FotoPerfil?url=',token)})

    this.intervalId = setInterval(async () => {
      await this.GetPeticionToken();
    }, 4 * 60 * 1000);
  }

  componentWillUnmount() {
    // Limpia el intervalo cuando el componente se desmonta
    clearInterval(this.intervalId);
  }
                        fghjghgt

  render() {
      console.log(this.state.DataTestimonios);

    return (

      <div className="App">
        <PlanHero />
        <WhatIsPlan />
        <LoveDecision />
        <FAQ />
        <Testimonials testimonios={this.state.DataTestimonios}/>
      </div>
    );
  }
}

export default PlanesFuturos;

